export let API_URL = 'http://panel.sheronsuditha.me:5000'


export let API_GET_USERS_URL = `${API_URL}/api/l1/info/users`
export let API_GET_SENSORS = `${API_URL}/api/l2/info/sensors`
export let API_GET_TRAFFIC_LIGHTS = `${API_URL}/api/l2/info/lights`
export let API_GET_SPEC_USER = `${API_URL}/api/l1/info/users`
export let API_USER_SETLEVEL = `${API_URL}/api/l1/manage/setlevel`
export let API_GET_LIGHT = `${API_URL}/api/l1/info/light`
export let API_UPDATE_COORDS = `${API_URL}/api/l3/lights/routedata`
export let API_UPDATE_PASSWORD = `${API_URL}/api/l3/update/password`

export let API_ADD_NEW_SENSOR = `${API_URL}/api/l2/set/sensors/register`